import type { Primitive } from "ts-essentials";

export default function htmlEscape(
  strings: TemplateStringsArray,
  ...keys: Primitive[]
) {
  const result = [strings[0]];

  for (let i = 0; i < keys.length; i++) {
    result.push(escapeString(String(keys[i])));
    result.push(strings[i + 1]);
  }

  return result.join("");
}

const dangerousRegExp = /["'&<>]/g;
const charMap = {
  '"': "&quot;",
  "'": "&#39;",
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
};

export function escapeString(s = "") {
  if (typeof s === "number") return s;

  return s.replaceAll(dangerousRegExp, (char) => {
    return charMap[char as keyof typeof charMap];
  });
}
